import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Structure } from '../../models/class/structure/structure';

@Injectable({
  providedIn: 'root'
})
export class StructureService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getStructure(): Observable<Structure[]> {
    return this.http.get<Structure[]>(`${environment.apiUrl}/structure`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addStructure(newStructure: Structure) {
    const formData = new FormData();
    formData.append('structureString', JSON.stringify(newStructure));

    return this.http.post(`${environment.apiUrl}/Structure/NewStructure`, formData);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */


  updateStructure(structure: Structure) {
    const formData = new FormData();
    formData.append('structureString', JSON.stringify(structure));

    return this.http.put(`${environment.apiUrl}/Structure/UpdateStructure`, formData);
  }

}
